import * as React from 'react';
import {BaseIconProps} from '../../types';

export const BaseCheckmarkSmall: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5303 8.46967C17.8232 8.76256 17.8232 9.23744 17.5303 9.53033L10.5303 16.5303C10.2374 16.8232 9.76256 16.8232 9.46967 16.5303L6.46967 13.5303C6.17678 13.2374 6.17678 12.7626 6.46967 12.4697C6.76256 12.1768 7.23744 12.1768 7.53033 12.4697L10 14.9393L16.4697 8.46967C16.7626 8.17678 17.2374 8.17678 17.5303 8.46967Z"
        fill={color}
      />
    </svg>
  );
};
